import React, { useState, useEffect } from "react";
import axios from "axios";
import "./financeList.css";
import "../finance/finance.css";
import { fmt, STATUS_LABEL } from "../finance/finance";

const FinanceList = ({ API_URL, company, onBack, onOpenOrder }) => {
    const [orders, setOrders] = useState([]);
    const [filter, setFilter] = useState("all");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        axios.post(`${API_URL}/getFinanceCompanyOrders`, { company })
            .then(({ data }) => { if (data.status === "success") setOrders(data.orders); })
            .catch((err) => console.error("getFinanceCompanyOrders:", err))
            .finally(() => setLoading(false));
    }, [API_URL, company]);

    const q = search.trim().toLowerCase();
    const filtered = orders
        .filter((o) => String(o.orderNumber).includes(q) || (o.title || "").toLowerCase().includes(q))
        .filter((o) => {
            if (filter === "debt") return o.isOverdue;
            if (filter === "paid") return o.status === "paid" && !o.isOverdue;
            if (filter === "partial") return o.status === "partial";
            if (filter === "transfer") return o.paymentType === "transfer";
            return true; // "all"
        });

    const countByStatus = (s) => {
        if (s === "debt") return orders.filter((o) => o.isOverdue).length;
        if (s === "transfer") return orders.filter((o) => o.paymentType === "transfer").length;
        return orders.filter((o) => o.status === s).length;
    };

    return (
        <>
            <div className="fn-topbar">
                <div className="fn-search">⌕ <input placeholder="Поиск по номеру или заказчику" value={search} onChange={(e) => setSearch(e.target.value)} /></div>
                <div className="fn-pagetitle">{company} — заказы</div>
                <button className="fn-btn-add" title="Скоро">+ Добавить заказ</button>
            </div>
            <button className="fn-back" onClick={onBack}> <i class="fa-solid fa-chevron-left"></i>Все заказы</button>

            <div className="fn-toolbar">
                <span className={`fn-chip${filter === "all" ? " active" : ""}`} onClick={() => setFilter("all")}>Все заказы</span>
                <span className={`fn-chip${filter === "debt" ? " active" : ""}`} onClick={() => setFilter("debt")}>Долг {countByStatus("debt")}</span>
                <span className={`fn-chip${filter === "paid" ? " active" : ""}`} onClick={() => setFilter("paid")}>Оплачено {countByStatus("paid")}</span>
                <span className={`fn-chip${filter === "transfer" ? " active" : ""}`} onClick={() => setFilter("transfer")}>Перечисление {countByStatus("transfer")}</span>
                <span className={`fn-chip${filter === "partial" ? " active" : ""}`} onClick={() => setFilter("partial")}>Оплачено частично {countByStatus("partial")}</span>
            </div>

            {loading ? <div className="fn-empty">Загрузка…</div> : filtered.length === 0 ? (
                <div className="fn-empty">Заказов не найдено</div>
            ) : (
                filtered.map((o) => (
                    <div className="fn-order-card" key={o.orderNumber} onClick={() => onOpenOrder({ orderNumber: o.orderNumber, requestType: o.requestType })}>
                        <div className="fn-top-row">
                            <div>
                                <div className="fn-order-num">№ {o.orderNumber}</div>
                                <div className="fn-order-name">{o.title}</div>
                            </div>
                            <div className="fn-pill-stack">
                                <span className={`fn-pill ${o.status}`}>{STATUS_LABEL[o.status]}</span>
                                {o.isOverdue && <span className="fn-pill debt">Долг</span>}
                            </div>
                        </div>
                        <div className="fn-order-meta">
                            <span>Дата <b>{o.date ? new Date(o.date).toLocaleDateString("ru-RU") : "—"}</b></span>
                            <span>Оператор <b>{o.tour_operator || "—"}</b></span>
                            <span>Маршрут <b>{o.tour || "—"}</b></span>
                            <span>Сумма <b>${fmt(o.grandTotal)}</b></span>
                        </div>
                    </div>
                ))
            )}
        </>
    );
};

export default FinanceList;